import _defineProperty from "/home/runner/work/minjunkweon.github.io/minjunkweon.github.io/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { htmlTreeAsString } from '@sentry/utils';
import '../node_modules/rrweb/es/rrweb/packages/rrweb/src/entries/all.js';
import { createBreadcrumb } from '../util/createBreadcrumb.js';
import record from '../node_modules/rrweb/es/rrweb/packages/rrweb/src/record/index.js';

/**
 * An event handler to react to DOM events.
 */
function handleDom(handlerData) {
  // Taken from https://github.com/getsentry/sentry-javascript/blob/master/packages/browser/src/integrations/breadcrumbs.ts#L112
  var target;
  var targetNode;

  // Accessing event.target can throw (see getsentry/raven-js#838, #768)
  try {
    targetNode = getTargetNode(handlerData);
    target = htmlTreeAsString(targetNode);
  } catch (e) {
    target = '<unknown>';
  }
  if (target.length === 0) {
    return null;
  }
  return createBreadcrumb({
    category: "ui.".concat(handlerData.name),
    message: target,
    data: _objectSpread({}, targetNode ? {
      nodeId: record.mirror.getId(targetNode)
    } : {})
  });
}
function getTargetNode(handlerData) {
  if (isEventWithTarget(handlerData.event)) {
    return handlerData.event.target;
  }
  return handlerData.event;
}
function isEventWithTarget(event) {
  return !!event.target;
}
export { handleDom };